import { LitElement } from 'lit';
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n } from '@lingui/core';
import { activateI18n } from '../src/utils/i18n';
const msgs = {"nb":{"icon.title.pin-marker":["Kartnål"]},"en":{"icon.title.pin-marker":["Map pin"]},"fi":{"icon.title.pin-marker":["Kartan osoitin"]},"da":{"icon.title.pin-marker":["Kortnål"]},"sv":{"icon.title.pin-marker":["Kartnål"]}}
activateI18n(msgs.en, msgs.nb, msgs.fi, msgs.da, msgs.sv);


export class IconPinMarker16 extends LitElement {
  render() {
      const title = i18n.t({ message: `Map pin`, id: 'icon.title.pin-marker', comment: 'Title for pin marker icon' });
      
      return html`<svg xmlns="http://www.w3.org/2000/svg"width="16"height="16"fill="none"viewBox="0 0 16 16" part="w-icon-pin-marker-16-part">${unsafeStatic(`<title>${title}</title>`)}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M8 .667c1.414 0 2.77.607 3.771 1.687s1.562 2.545 1.562 4.073c0 2.343-2.893 6.442-4.417 8.44a1.2 1.2 0 0 1-.41.344 1.11 1.11 0 0 1-1.012 0 1.2 1.2 0 0 1-.41-.345c-1.523-1.995-4.417-6.096-4.417-8.44 0-1.527.561-2.992 1.562-4.072S6.585.667 7.999.667Z"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M8 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4"></path></svg>`; }
}
if (!customElements.get('w-icon-pin-marker-16')) {
  customElements.define('w-icon-pin-marker-16', IconPinMarker16);
}